import { useState } from 'react'

import { Tooltip } from '@twistopayments/design-system/components/atoms/tooltip'
import { Typography } from '@twistopayments/design-system/components/atoms/typography'
import { GiftOutlineIcon } from '@twistopayments/design-system/icons/inline'

import type { BlocksPromoComponent } from '@twisto/api-cms'

import { useHighlightedText } from 'homepage/libs/hooks'

import * as styles from './promo.styles'

export const Promo = ({
  title,
  highlighted,
  code,
  url,
  message,
}: BlocksPromoComponent) => {
  const { before, after, highlight } = useHighlightedText(title, highlighted)
  const [isCodeCopied, setIsCodeCopied] = useState(false)

  const handlePromoClick = () => {
    if (code) {
      navigator.clipboard.writeText(code)
      setIsCodeCopied(true)

      return
    }

    if (url) {
      window.open(url, '_blank')
    }
  }

  const PromoContent = () => (
    <button
      css={[styles.promo, (code || url) && styles.clickable]}
      onClick={handlePromoClick}
    >
      <GiftOutlineIcon />
      <Typography>
        {before}
        <span css={styles.highlighted}>{highlight}</span>
        {after}
      </Typography>
    </button>
  )

  if (isCodeCopied) {
    return (
      <Tooltip css={styles.tooltip} id={code || ''} text={message || ''}>
        <PromoContent />
      </Tooltip>
    )
  }

  return <PromoContent />
}
